module.exports = __webpack_public_path__ + "static/img/login.d4a06ac6.png";